// extracted by mini-css-extract-plugin
export default {"searchLabel":"SearchLabel_searchLabel__IZVh+","titleWrapper":"SearchLabel_titleWrapper__BPFXV","title":"SearchLabel_title__zO5Qi","tooltipIcon":"SearchLabel_tooltipIcon__HARSN"};